"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/click-events-have-key-events */
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var actions = __importStar(require("./SidebarActions"));
var userActions_1 = require("../user/userActions");
var HeaderLogin_1 = __importDefault(require("../header/HeaderLogin"));
var react_i18next_1 = require("react-i18next");
var LanguageSelector_1 = __importDefault(require("../header/LanguageSelector"));
var SidebarCustom = function (_a) {
    var children = _a.children, sidebar = _a.sidebar, closeSidebar = _a.closeSidebar, visible = _a.visible, isAuthorized = _a.isAuthorized, address = _a.address, logout = _a.logout;
    var _b = (0, react_1.useState)(false), lightTheme = _b[0], setLightTheme = _b[1];
    var _c = (0, react_1.useState)(false), isStarsOpen = _c[0], setStarsOpen = _c[1];
    var _d = (0, react_1.useState)(false), isCollectablesOpen = _d[0], setCollectablesOpen = _d[1];
    var pageName = window.location.pathname;
    (0, react_1.useEffect)(function () {
        var theme = window.localStorage.getItem("trybe_theme")
            ? window.localStorage.getItem("trybe_theme")
            : "light";
        if (theme === "light") {
            setLightTheme(true);
        }
        else {
            setLightTheme(false);
        }
    });
    var menuItems = {
        stars: [
            {
                name: "LoopFans para Creadores",
                link: "/",
                active: true,
            },
            {
                name: "Salud, Fitness y Bienstar",
                link: "/fitness",
                active: true,
            },
            {
                name: "Influenciadores",
                link: "/influencer",
                active: true,
            },
            {
                name: "Deportistas y Atletas",
                link: "/sports",
                active: true,
            },
            {
                name: "Music NFTs",
                link: "/music",
                active: true,
            },
        ],
        types: [
            {
                name: "Todos los Tipos",
                link: "/",
                active: true,
            },
            {
                name: "Concertos y Tickets para Eventos",
                link: "/events",
                active: true,
            },
            {
                name: "Membresias Privadas",
                link: "/private-memberships",
                active: true,
            },
            {
                name: "Medios Digitales",
                link: "/digital",
                active: true,
            },
            /* {
              name: "Giveaways",
              link: "/giveaways",
              active: false,
            },
            {
              name: "Merchndise",
              link: "/",
              active: false,
            },
            {
              name: "Metaverse experience",
              link: "/metaverse",
              active: false,
            },
            {
              name: "Tokens and Crypto",
              link: "/crypto",
              active: false,
            }, */
        ],
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: visible
            ? "sidebarVisible sidebar-wrapper cz-mobile-menu cz-mobile-menu--blur"
            : "sidebarVisible sidebar-wrapper cz-mobile-menu" }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Sidebar.Pushable, __assign({ as: semantic_ui_react_1.Segment }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Sidebar, __assign({ as: semantic_ui_react_1.Menu, animation: "overlay", icon: "labeled", inverted: true, vertical: true, direction: "right", visible: visible, width: "wide" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Segment, __assign({ inverted: true, className: "sidebar-main" }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Segment, __assign({ inverted: true, className: "controls-panel-wrapper" }, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Row, { children: [(0, jsx_runtime_1.jsx)("img", { src: "/fanslogo2.png", alt: "", className: "sideLogo" }), (0, jsx_runtime_1.jsx)("p", __assign({ className: "closeBtn", onClick: closeSidebar }, { children: (0, jsx_runtime_1.jsx)("img", { src: "/menu-close.svg", alt: "close" }) })), (0, jsx_runtime_1.jsx)(HeaderLogin_1.default, { isAuthorized: address, logout: logout, address: address })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Row, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.List, __assign({ link: true, inverted: true }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: { borderRadius: "30px" }, className: pageName === "/" ? "nav-link active" : "nav-link", onClick: closeSidebar }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/", onClick: function () { return setStarsOpen(!isStarsOpen); } }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navHome" }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ style: { borderRadius: "30px" }, className: pageName.includes("clubs") &&
                                                        pageName.includes("fanclubs")
                                                        ? "nav-link active"
                                                        : "nav-link", onClick: closeSidebar }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://app.loop.fans/clubs/" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "LOOPS" }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ style: { borderRadius: "30px" }, className: pageName.includes("stars")
                                                        ? "nav-link active"
                                                        : "nav-link", onClick: closeSidebar }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://awards.loop.fans/" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "musicAwards" }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ style: { borderRadius: "30px" }, className: pageName.includes("stars")
                                                        ? "nav-link active"
                                                        : "nav-link", onClick: closeSidebar }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://app.loop.fans" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "membersArea" }) })) })), pageName.includes("stars") ||
                                                    pageName.includes("collectibles") ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })), (0, jsx_runtime_1.jsx)(LanguageSelector_1.default, {})] })] })) })) })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Sidebar.Pusher, __assign({ onClick: function () {
                        if (visible)
                            closeSidebar();
                    }, dimmed: visible }, { children: children }))] })) })));
};
var mapStateToProps = function (state) { return ({
    visible: state.sidebar.visible,
}); };
exports.default = (0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(mapStateToProps, function (dispatch) { return ({
    closeSidebar: function () {
        dispatch(actions.closeSidebar());
    },
    signOut: function () {
        dispatch((0, userActions_1.userSignOut)());
    },
    resetModal: function () {
        dispatch((0, userActions_1.returnToLoginMode)());
    },
}); })(SidebarCustom));
